/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const StageStatus = {
    Init: 'INIT',
    Completed: 'COMPLETED',
    Error: 'ERROR'
} as const;
export type StageStatus = typeof StageStatus[keyof typeof StageStatus];

